import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import pluralize from 'pluralize';
class Translate extends Component {
  static propTypes = {
    translateKey: PropTypes.string,
    capitalize: PropTypes.any,
    plurals: PropTypes.any,
    id: PropTypes.any
  }

  static contextTypes = {
    t: PropTypes.func
  }

  buildTranslatedText = () => {
    const {t} = this.context;
    const {translateKey, capitalize, plurals, id = ''} = this.props;
    const isFirstCapitalize = capitalize ? 'first-capitalize' : '';
    const className = `translate-key translateKey-${translateKey} ${isFirstCapitalize}`;

    // Check window.customTerms first (direct API), then fall back to i18n context
    let translatedText = translateKey;
    if (window.customTerms) {
      // Find matching key case-insensitively
      const matchingKey = Object.keys(window.customTerms).find(
        key => key.toLowerCase() === translateKey.toLowerCase()
      );
      if (matchingKey !== undefined) {
        translatedText = window.customTerms[matchingKey];
      } else if (t) {
        translatedText = t(translateKey);
      }
    } else if (t) {
      translatedText = t(translateKey);
    }

    if (plurals) {
      translatedText = pluralize(translatedText);
    }

    return <span id={id} className={className}>{translatedText}</span>;
  }

  render() {
    return this.buildTranslatedText();
  }
}

const mapStateToProps = (state) => {
  return {
    i18nState: state.i18nState
  };
};

export default connect(mapStateToProps)(Translate);



// WEBPACK FOOTER //
// ./src/components/translate/index.js